import Icon from "./IconBase.js";
const GraphIconOutline = (props) => {
  return (
    <Icon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.736398 0.000117575C0.538299 0.00363119 0.349739 0.0852809 0.211704 0.22733C0.0738352 0.369545 -0.0022904 0.560449 5.25222e-05 0.758363V23.2453C-0.000784077 23.444 0.077519 23.6351 0.217559 23.7762C0.357432 23.9174 0.547834 23.997 0.746622 23.9979H23.2335C23.4353 24.0024 23.6302 23.9253 23.7745 23.7842C23.9187 23.6432 24 23.4499 24 23.2483C24 23.0465 23.9187 22.8533 23.7745 22.7122C23.6302 22.5712 23.4353 22.4942 23.2335 22.4987H1.49918V0.758368C1.50153 0.55575 1.42172 0.360833 1.27799 0.217954C1.13444 0.0750697 0.939033 -0.00339895 0.736398 0.000117575ZM20.5617 11.289C20.5467 11.29 20.5314 11.2915 20.5164 11.2933H16.9705H16.9707C16.7026 11.2933 16.4548 11.4364 16.3208 11.6686C16.1868 11.9007 16.1868 12.1868 16.3208 12.4189C16.4548 12.6509 16.7026 12.794 16.9707 12.794H18.7947L13.7718 17.8842L9.50579 14.8464C9.37228 14.7514 9.21149 14.7027 9.04787 14.7077C8.88424 14.7127 8.7268 14.7713 8.59946 14.8742L3.05955 19.423C2.89575 19.5458 2.78917 19.7302 2.76474 19.9334C2.74014 20.1367 2.80004 20.3412 2.93005 20.4993C3.06022 20.6574 3.24928 20.7554 3.45341 20.7707C3.6577 20.7857 3.85915 20.7168 4.01122 20.5796L9.10311 16.3956L13.4232 19.4773V19.4771C13.5687 19.5802 13.7463 19.6279 13.9239 19.6118C14.1014 19.5958 14.2676 19.5168 14.3922 19.3893L19.8366 13.8687V15.6606C19.8179 15.8702 19.888 16.078 20.0301 16.2335C20.1721 16.3887 20.3729 16.4772 20.5834 16.4772C20.7938 16.4772 20.9946 16.3887 21.1367 16.2335C21.2786 16.078 21.3488 15.8702 21.3299 15.6606V12.1455C21.3617 11.9255 21.2943 11.7028 21.1459 11.5375C20.9975 11.3722 20.7835 11.2812 20.5614 11.2891L20.5617 11.289Z"
          fill="#757575"
        />
      </svg>
    </Icon>
  );
};
export default GraphIconOutline;
